module.exports = __webpack_public_path__ + "img/yellow-circle-table-5.02adce7e.png";